import classNames from "classnames";
import styles from "./ShowPosterFallback.module.css";

//#region [Props]
type ShowPosterFallbackProps = {
    numPlaceholderPosters?: number;
    size?: "small" | "large";
    className?: string;
};
//#endregion

//#region [Component]
export default function ShowPosterFallback({ numPlaceholderPosters = 4, size = "large", className }: ShowPosterFallbackProps) {
    const placeholders = [];
    for (let p = 0; p < numPlaceholderPosters; p++) {
        placeholders.push(<FallbackPoster key={p} size={size} />)
    }
    return <div className={classNames(styles.ShowPosterFallback, numPlaceholderPosters < 5 ? styles.PostersCentered : undefined, className)}>
        {placeholders}
    </div>;
}
//#endregion

function FallbackPoster({ size }: { size?: "small" | "large"; }) {
    return <div className={classNames(styles.FallbackPoster, size === "small" ? styles.SizeSmall : undefined)}>
        <div className={styles.Activity}></div>
    </div>
}